module.exports = __webpack_public_path__ + "img/ocean.a63ca831.png";